/* eslint-disable no-restricted-globals */
import { webviewInfo } from '@ali/amap-lib';
import actConfig from './config.act';
//* 接口名称
const AOS_NAME = actConfig.aosName;
const AOS_LINE = actConfig.aosLine;
const isPublic = webviewInfo.isPublic();
const host = window.location.hostname;
const productionHostList = [
  'wap.amap.com',
  'free-wap.amap.com',
  'prewap.amap.com',
  'activity.gaode.com  ',
  'activity2.gaode.com',
  'activity.anav.com ',
  'activity2.anav.com',
  'cache.amap.com',
  'free-cache.amap.com',
  'cache.gaode.com',
  'free-cache.gaode.com',
  'cache1.gaode.com',
  'cache1.autonavi.com',
  'm.autonavi.com'
];
const isPreEnv = location.search.indexOf('pre') >= 0
  && !productionHostList.some((item) => item === host); // 是否预发环境
console.log(`%cAOSURL 是否强制使用预发环境-->>${isPreEnv}`, 'color: orange');

// nodejs 环境
if (
  typeof module !== 'undefined'
  && module.exports
  && typeof window === 'undefined'
) {
  location = {
    protocol: 'http:'
  };
}

const AOS_URL = Object.create(
  Object.create(null, {
    aosName: {
      value: AOS_NAME
    }
  })
); // output
const AOS_PRE_DEV = `//sns.testing.amap.com/ws/${AOS_LINE}/`; //* 测试环境接口域名
const AOS_PRE_PRE = `//pre-sns.amap.com/ws/${AOS_LINE}/`; // 预发环境接口域名
const AOS_PRE_PUBLIC = `//sns.amap.com/ws/${AOS_LINE}/`; //* 正式环境接口域名

const AOS_URL_GROUP = {
  // 首页
  index: {
    test: '//sns.testing.amap.com/ws/activity/invite_new/gass/index',
    pre: '//pre-sns.amap.com/ws/activity/invite_new/gass/index',
    public: '//sns.amap.com/ws/activity/invite_new/gass/index',
  },
  // 为好友助力
  call_back: {
    test: '//sns.testing.amap.com/ws/activity/invite_new/gass/call_back',
    pre: '//pre-sns.amap.com/ws/activity/invite_new/gass/call_back',
    public: '//sns.amap.com/ws/activity/invite_new/gass/call_back',
  },
  // 组团领取奖励
  do_reward: {
    test: '//sns.testing.amap.com/ws/activity/invite_new/gass/do_reward',
    // pre: '//pre-sns.amap.com/ws/activity/invite_new/gass/do_reward',
    pre: '//sns.amap.com/ws/activity/invite_new/gass/do_reward',
    public: '//sns.amap.com/ws/activity/invite_new/gass/do_reward',
  },
  // 获取验证码
  verify_code: {
    test: '//sns.testing.amap.com/ws/activity/invite_new/send/verify_code',
    // pre: '//pre-sns.amap.com/ws/activity/invite_new/send/verify_code',
    pre: '//sns.amap.com/ws/activity/invite_new/send/verify_code',
    public: '//sns.amap.com/ws/activity/invite_new/send/verify_code',
  },
  // 邀请记录通知开关
  notice_switch: {
    test: '//sns.testing.amap.com/ws/activity/invite_new/notice_switch',
    // pre: '//pre-sns.amap.com/ws/activity/invite_new/notice_switch',
    pre: '//sns.amap.com/ws/activity/invite_new/notice_switch',
    public: '//sns.amap.com/ws/activity/invite_new/notice_switch',
  },
  // 任务列表
  taskList: {
    test: '//sns.testing.amap.com/ws/activity/basic/task_center/task_list',
    // pre: '//pre-sns.amap.com/ws/activity/basic/task_center/task_list',
    pre: '//sns.amap.com/ws/activity/basic/task_center/task_list',
    public: '//sns.amap.com/ws/activity/basic/task_center/task_list',
  },
  // 任务上报
  taskReport: {
    test: '//sns.testing.amap.com/ws/activity/basic/task_center/report',
    // pre: '//pre-sns.amap.com/ws/activity/basic/task_center/report',
    pre: '//sns.amap.com/ws/activity/basic/task_center/report',
    public: '//sns.amap.com/ws/activity/basic/task_center/report',
  },
  /*
  运营活动通用接口
   */
  wechat: {
    // 微信端生成标识码
    test: '//sns.testing.amap.com/ws/acs/wechat/guard_code',
    public: '//sns.amap.com/ws/acs/wechat/guard_code'
  },
  voucher: {
    // 提现问卷
    test: '//sns.testing.amap.com/ws/activity/activity_base/wallet/voucher',
    public: '//sns.amap.com/ws/activity/activity_base/wallet/voucher'
  },
  question_submit: {
    // 问卷提交
    test:
      '//sns.testing.amap.com/ws/activity/activity_base/wallet/voucher_submit',
    public: '//sns.amap.com/ws/activity/activity_base/wallet/voucher_submit'
  },
  owner_cash_to_wallet: {
    // 钱包提现
    test:
      '//sns.testing.amap.com/ws/activity/activity_base/wallet/withdraw-cash',
    public: '//sns.amap.com/ws/activity/activity_base/wallet/withdraw-cash'
  },
  address: {
    // 编辑地址
    test: '//sns.testing.amap.com/ws/activity/activity_base/owner/address-edit',
    public: '//sns.amap.com/ws/activity/activity_base/owner/address-edit'
  },
  invite: {
    // 分享给端内好友
    test: '//sns.testing.amap.com/ws/activity/friend/invite',
    public: '//sns.amap.com/ws/activity/friend/invite'
  },
  friend_list: {
    // 好友相关
    test: '//sns.testing.amap.com/ws/activity/friend/list',
    public: '//sns.amap.com/ws/activity/friend/list'
  },
  share_conf: {
    // 分享文案及配置
    test: '//sns.testing.amap.com/ws/activity/activity_base/share/share-conf',
    pre: '//pre-sns.amap.com/ws/activity/activity_base/share/share-conf',
    public: '//sns.amap.com/ws/activity/activity_base/share/share-conf'
  },
  external_share: {
    // 端外分享文案配置
    test:
      '//sns.testing.amap.com/ws/activity/activity_base/share/external-share-conf',
    public: '//sns.amap.com/ws/activity/activity_base/share/external-share-conf'
  },
  share_command: {
    // 口令
    test: '//sns.testing.amap.com/ws/oss/operation/share-code',
    public: '//sns.amap.com/ws/oss/operation/share-code'
  },
  create_image: {
    // base64生成图片
    test: '//sns.testing.amap.com/ws/activity/activity_base/create_image',
    public: '//sns.amap.com/ws/activity/activity_base/create_image'
  },
  transform: {
    // 转短链
    test: '//m5.amap.com/ws/mapapi/shortaddress/transform',
    public: '//m5.amap.com/ws/mapapi/shortaddress/transform'
  }
};

const DEV_HOST = window.location.protocol + AOS_PRE_DEV + AOS_NAME;
const PRE_HOST = window.location.protocol + AOS_PRE_PRE + AOS_NAME;
const ONLINE_HOST = window.location.protocol + AOS_PRE_PUBLIC + AOS_NAME;
let HOST;
if (isPublic) {
  HOST = ONLINE_HOST;
} else if (isPreEnv) {
  HOST = PRE_HOST;
} else {
  HOST = DEV_HOST;
}

/**
 *
 * @param group
 */
const merge = (group) => {
  Object.keys(group).forEach((key) => {
    const groupItem = group[key];
    const hasTest = groupItem.test !== undefined;
    if (hasTest) {
      if (isPreEnv) {
        // fallback to public
        AOS_URL[key] = window.location.protocol + (groupItem.pre || groupItem.public);
      } else if (isPublic) {
        AOS_URL[key] = window.location.protocol + groupItem.public;
      } else {
        AOS_URL[key] = window.location.protocol + groupItem.test;
      }
    } else {
      AOS_URL[key] = `${HOST}/${groupItem}`;
    }
  });
};

merge(AOS_URL_GROUP);

// eslint-disable-next-line no-underscore-dangle
AOS_URL._install = merge;

export default AOS_URL;
